<template>
  <div class="frame" v-if="alertError.status">
    <div class="modal-error">
      <v-icon class="icon-modal-error" icon="mdi-alert"></v-icon>
      <span class="title-erro">ERRO</span>
      <p>{{ alertError.message }}</p>

      <a v-if="alertError.type === 1" :href="`/edicao/${idCuco}/finalizado`">
        <div class="button">OK</div>
      </a>

      <div
        v-if="alertError.type === 2"
        @click="alertError.status = false"
        class="button"
      >
        OK
      </div>
    </div>
  </div>
  <div class="loading-full" v-if="loadingPage">
    <span class="loader"></span>
  </div>
  <div class="start-prova">
    <div class="header-instrucoes">
      <div class="logo-prova">
        <v-img
          :src="require('@/assets/img/logo-c.png')"
          max-height="50"
        ></v-img>
      </div>
      <div class="text-edicao">EDIÇÃO <b>CUCO 2025</b></div>
    </div>
    <div class="box-end-prova">
      <h3 class="title-tempo-esgotado">PROVA FINALIZADA</h3>
      <v-img
        max-height="250"
        width="500"
        :src="require('@/assets/img/list.png')"
      ></v-img>
      <p class="info-tempo-esgotado">
        <b>Olá {{ user }}.</b> Sua prova foi finalizada com sucesso!<br />
        Todas as questões respondidas foram salvas e a sua prova finalizada.<br />
        Agora, é só aguardar pelo resultado. Desejamos boa sorte e excelentes
        estudos!
      </p>
      <v-btn
        color="green"
        block
        prepend-icon="mdi-check"
        class="pulse"
        size="large"
        @click="voltarDash()"
        >PRONTO</v-btn
      >
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { getUserInfo } from "@/util/auth";

import ProvaService from "@/services/prova.service";

function isUndefined(variable) {
  return typeof variable === "undefined";
}

export default defineComponent({
  name: "TempoEsgotadoView",
  props: {
    cuco: {
      type: String,
    },
  },
  setup(props) {
    const loadingPage = ref(true);
    const idCuco = ref(props.cuco);

    const user = ref("");

    const alertError = ref({
      status: false,
      message: "",
      type: 1,
    });

    const voltarDash = async () => {
      window.location.href = `${process.env.VUE_APP_URL_DASH}edicoes/${idCuco.value}`;
    };
    return {
      voltarDash,
      loadingPage,
      user,
      alertError,
      idCuco,
    };
  },

  async created() {
    const data = getUserInfo();
    this.user = data.name.split(" ")[0];

    try {
      const router = useRouter();
      const response = await ProvaService.status(this.cuco);
      if (response.data) {
        if (response.data.statusInit === 1) {
          //Finalizou o teste
          this.loadingPage = false;
        } else if (response.data.statusInit === 2) {
          //Não tem prova atribuida - Instrucoes
          router.push(`/edicao/${this.cuco}/instrucoes`);
        } else if (response.data.statusInit === 3) {
          //Não iniciou a prova - Instrucoes
          router.push(`/edicao/${this.cuco}/instrucoes`);
        } else if (response.data.statusInit === 4) {
          //Prova iniciada
          router.push(`/edicao/${this.cuco}`);
        } else if (response.data.statusInit === 5) {
          //Tempo finalizado
          router.push(`/edicao/${this.cuco}/tempo-esgotado`);
        } else {
          this.alertError.message =
            "Erro de Rede! Recarregue a página e tente novamente.";
          this.alertError.type = 1;
          this.alertError.status = true;
        }
      }
    } catch (erro) {
      this.loadingPage = false;
      if (
        !isUndefined(erro.response?.data.message) &&
        erro.response?.data.message !== null &&
        erro.response?.data.message !== ""
      ) {
        this.alertError.message = erro?.response?.data?.message;
        this.alertError.type = 1;
        this.alertError.status = true;
      } else {
        this.alertError.message =
          "Erro de Rede! Recarregue a página e tente novamente.";
        this.alertError.type = 1;
        this.alertError.status = true;
      }
    }
  },
});
</script>
<style scoped>
.start-prova {
  width: 100%;
  height: 100%;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 30px 3% 60px;
}
.box-end-prova {
  display: flex;
  background-color: #fff;
  padding: 16px;
  border-radius: 6px;
  width: 100%;
  margin: 20px 0;
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
  border-radius: 4px;
  /* box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12)); */
  flex-direction: column;
  align-items: center;
}
.item-instrucao-prova {
  font-size: 1rem;
  margin: 16px 0;
}
.item-instrucao-prova span {
  font-weight: 900;
  color: #c95d21;
  border-radius: 50%;
  margin-right: 1px;
  min-width: 30px;
  padding: 1px;
}
.title-instrucao {
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 10px;
}
.sub-title-instrucao {
  font-size: 1rem;
  margin-bottom: 10px;
}
.confirmacao-check {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  user-select: none;
}
.check-icon-confirmacao {
  font-size: 1.3rem;
  margin-right: 16px;
  color: #4caf50;
}
.text-confirmacao {
  font-size: 1.1rem;
}
.pulse {
  box-shadow: 0 0 0 rgba(76 175 80 / 0.6);
  animation: pulse 2s infinite;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(76 175 80 / 0.6);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(76 175 80 / 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(76 175 80 / 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(76 175 80 / 0.6);
    box-shadow: 0 0 0 0 rgba(76 175 80 / 0.6);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(76 175 80 / 0);
    box-shadow: 0 0 0 10px rgba(76 175 80 / 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(76 175 80 / 0);
    box-shadow: 0 0 0 0 rgba(76 175 80 / 0);
  }
}
.title-sistema {
  font-size: 2rem;
}
.header-instrucoes {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.text-edicao {
  margin: 5px 0 0;
  font-size: 1.2rem;
}
.logo-prova {
  justify-content: flex-start;
  align-items: center;
  display: flex;
  width: 140px;
  flex-direction: row;
}
.atencao-txt {
  color: #b71c1c;
  font-weight: 700;
  text-decoration: underline;
}
.desabilitado-inicio-prova {
  cursor: no-drop;
  pointer-events: auto;
  background-color: #777 !important;
}
.loading-full {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: #f47935;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  width: 50px;
  height: 50px;
  border: 6px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.img-clock {
  display: flex;
  width: 100%;
}
.info-tempo-esgotado {
  text-align: center;
  font-size: 1.2rem;
  margin: 30px 0;
}
.title-tempo-esgotado {
  text-align: center;
  font-size: 1.6rem;
  margin: 0 0 30px;
  font-weight: 900;
  letter-spacing: 2;
}
</style>
